module.exports = __webpack_public_path__ + "img/telephonelandingfarm.818b925b.png";